import { render, staticRenderFns } from "./UserButton.vue?vue&type=template&id=5b005c9c&scoped=true&"
import script from "./UserButton.vue?vue&type=script&lang=js&"
export * from "./UserButton.vue?vue&type=script&lang=js&"
import style0 from "./UserButton.vue?vue&type=style&index=0&id=5b005c9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b005c9c",
  null
  
)

export default component.exports